import { Lookup } from './lookup.model'
import { OptionSet } from './optionSet.model'

export class AddUpdProcesoInput {

  public IdProceso: string;
  public Institucion: Lookup;
  public Sede: Lookup;
  public OfertaAdmision: Lookup;
  public Contacto: Lookup;
  public Carrera: Lookup;
  public PeriodoAdm: Lookup;
  public Area: Lookup;
  public Jornada: OptionSet;

  public constructor(
    institucion: Lookup,
    sede: Lookup,
    contacto: Lookup,
    carrera: Lookup,
    periodoAdm: Lookup) {
    this.Institucion = institucion;
    this.Sede = sede;
    this.Contacto = contacto;
    this.Carrera = carrera;
    this.PeriodoAdm = periodoAdm;
  }
}

export class UpdProcesoInput extends AddUpdProcesoInput {
  public FasePortal: OptionSet = new OptionSet('');
  // Matricula
  public CopagoMatricula: any;
  public CopagoMatricula1: any;
  public CopagoMatricula2: any;


  // Descto Matricula
  public ProcentajeDesMatricula: any;
  public ValorDescMatricula: any;
  public CopagoMatriculaTotal: any;


  // Arancel
  public CopagoArenceles: any;
  public CopagoAranceles1: any;
  public CopagoAranceles2: any;


  // Mineduc
  public MontoBecaAsignable: any;
  public MontoBeca: any;
  public ValorColegAPagar: any;


  // PSU
  public ValorColegAPagar1: any;
  public Porcentaje: any;
  public ValorDescuento: any;


  // Sto Tomas
  public PorcentajeDescuentoBecode: any;
  public ValorDescuentoBecode: any;
  public ValorColegAPagar2: any;


  // CAE
  public MontoCae: any;
  public DeseaUsarCredito: any;
  public MontoAUtilizar: any;
  public ColegaDoc: any;

  //Pagar todo al contado
  public MontoMatriculaPP: number;
  public DescuentoProntoPago: number;
  public MontoColegiaturaPP: number;
  public CheckProntoPago: boolean;

  // Pago al dia
  public MontoAlDia: any;
  public FechaDocumento: any;
  public AbonoMatricula: any;
  public AbonoColegiatura: any;
  public MatriculaADoc: any;
  public ColegaDoc1: any;


  // Pago Colegiatura Plazo
  public Total1Sem: any;
  public Total2Sem: any;
  public TipoDePago1: any;
  public TipoDePago2: any;
  public Cuotas1: any;
  public Cuotas2: any;
  public FechaPago1: any;
  public FechaPago2: any;

  public constructor(
    institucion: Lookup,
    sede: Lookup,
    contacto: Lookup,
    carrera: Lookup,
    periodoAdm: Lookup) {
    super(
      institucion,
      sede,
      contacto,
      carrera,
      periodoAdm);
  }

}
